import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { verifyEmail } from '../../api/client';

export default function VerifyEmail() {
  const { token } = useParams();
  const [status, setStatus] = useState('verifying'); // verifying | success | error
  const [error, setError] = useState('');

  useEffect(() => {
    async function verify() {
      try {
        await verifyEmail(token);
        setStatus('success');
      } catch (err) {
        setError(err.message || 'Verification failed');
        setStatus('error');
      }
    }
    verify();
  }, [token]);

  return (
    <div className="min-h-screen bg-navy flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src="/bcd-icon.png" alt="BCD" className="h-10 mx-auto mb-3" />
          <h1 className="text-2xl font-heading font-bold text-white uppercase tracking-wide">
            Email Verification
          </h1>
        </div>

        <div className="bg-white rounded-2xl shadow-xl p-8 text-center">
          {status === 'verifying' && (
            <p className="text-txt-secondary">Verifying your email...</p>
          )}
          {status === 'success' && (
            <>
              <p className="text-txt-primary mb-4">Your email has been verified. You can now log in.</p>
              <Link to="/login" className="btn-gold inline-block px-6 py-2 text-sm font-semibold">
                Log in
              </Link>
            </>
          )}
          {status === 'error' && (
            <>
              <p className="text-red-500 mb-4">{error}</p>
              <Link to="/login" className="text-gold-dark font-semibold hover:underline">
                Back to login
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
